export type SeasonYears = {
  current: number;
  next: number;
};

export function getSeasonYears(now: Date): SeasonYears {
  const current = now.getFullYear();
  return { current, next: current + 1 };
}

export function getSchoolYearLabel(startYear: number): string {
  const endYear = String((startYear + 1) % 100).padStart(2, "0");
  return `${startYear}\u2013${endYear}`;
}
